const MODULES = {
  MEMBER_OUTREACH: "Member Outreach",
  PROVIDER_OUTREACH: "Provider Outreach",
  PHARMACY_OUTREACH: "Pharmacy Outreach",
  MANUAL_TASKS: "Manual Tasks",
  MEMBER_REPORTING: "Member Reporting",
  SUPERVISOR_REPORTING: "Supervisor Reporting",
  INVOICE_REPORTING: "Invoice Reporting",
  ROLE_MANAGEMENT: "Role Management",
  ALL_MEMBERS: "All Members",
  MEMBER_MONITORING: "Member Monitoring",
  DASHBOARD: "Dashboard",
  CAG_CONFIGURATION: "CAG Configuration",
  ASSESSMENT_CONFIGURATION: "Assessment Configuration",
  CAG_PLUS_ADMIN_CONFIGURATION: "CG+ Assessment Templates",
};

export const ROUTE_MODULE_MAPPING = [
  { module: "Dashboard", patterns: ["dashboard"] },
  { module: "Manual Tasks", patterns: ["manual-tasks"] },
  { module: "Role Management", patterns: ["role-management"] },
  { module: "Member Outreach", patterns: ["members/", "member-outreach"] },
  {
    module: "Pharmacy Outreach",
    patterns: ["pharmacy-outreach", "pharmacyprofile"],
  },
  {
    module: "Provider Outreach",
    patterns: ["provider-outreach", "providerprofile"],
  },
  { module: "Member Reporting", patterns: ["reporting/member-reporting"] },
  {
    module: "Supervisor Reporting",
    patterns: ["reporting/supervisor-reporting"],
  },
  { module: "Invoice Reporting", patterns: ["reporting/invoice-reporting"] },
  { module: "CAG Configuration", patterns: ["cag-configuration"] },
  { module: "Assessment Configuration", patterns: ["assessment-config"] },
  { module: "Care Guide Performance", patterns: [] },
  { module: "CG+ Assessment Templates", patterns: ["cg-config"] },
];
export default MODULES;
